import { render } from "./AbilityComponent.vue?vue&type=template&id=135311ee&scoped=true"
import script from "./AbilityComponent.vue?vue&type=script&lang=js"
export * from "./AbilityComponent.vue?vue&type=script&lang=js"

import "./AbilityComponent.vue?vue&type=style&index=0&id=135311ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135311ee"]])

export default __exports__